const { getCurrentStage } = require('./common');

const DEFAULT_STAGE = 'msgeo.qa.paypal.com';
const DEFAULTS = {
    domain: 'paypal.cn',
    cdnhost: 'objects.paypal.cn',
    ppinc: 'gopayinc.com.cn',
    ppcorp: 'gopaycorp.com.cn',
    stage: DEFAULT_STAGE
};
function settings() {
    const result = { ...DEFAULTS };
    const [ stage ] = getCurrentStage(DEFAULT_STAGE);
    result.stage = stage;
    return result;
}

module.exports = settings;
module.exports.DEFAULTS = DEFAULTS;
